var React = require('react');

function ProfileInput (props) {
    return React.createElement("svg",props);
}

ProfileInput.defaultProps = {"width":"1000","height":"1000","viewBox":"0 0 1000 1000"};

module.exports = ProfileInput;

ProfileInput.default = ProfileInput;
